export default defineNuxtPlugin(async () => {
  // Persist storage if supported
  if ('storage' in navigator && 'persist' in navigator.storage) {
    await navigator.storage.persist()
  }
})
